export const PM_MENU_RAW_WIDTH = 228
export const PM_MENU_WIDTH = `${PM_MENU_RAW_WIDTH}px`
